import { render, staticRenderFns } from "./UniversalLoginModal.vue?vue&type=template&id=2ebc0f2c&scoped=true"
import script from "./UniversalLoginModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UniversalLoginModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UniversalLoginModal.vue?vue&type=style&index=0&id=2ebc0f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc0f2c",
  null
  
)

export default component.exports